import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component, Fragment } from 'react';
import { DataSociete } from '../../data/DataSociete.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
******************************************************************************
PROPS :
    ATTRIBUTS :
        int     idSociete                   ID de la société à modifer
        bool    isOpen                      détermine si panel ouvert ou non
    METHODES :
        void    onAnnulation                méthode appelée à la fermeture
        void    onEnregistrement            méthode appelée à l'enregistrement
        void    onSuppression               méthode appelée à la suppression
******************************************************************************
*/

export class FicheSociete extends Component {
    constructor(props) {
        super(props);
        this.objetState = {
            estSocieteReseau: true,
            nom: "",
            honoraires: "",
            nombreOptionsParOperation: "",
            raisonSociale: "",
            siren: "",
            siret: "",
            rcs: "",
            adresse: "",
            cp: "",
            ville: "",
            pays: "",
            telephone: "",
            fax: "",
            errorMessages: {
                honoraires: "",
                nombreOptionsParOperation: "",
                siren: "",
                siret: "",
            },
            /* ----- */
            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: '',
            onActiveBoutonEnregistrer: false
        };
        this.state = this.objetState;
    };

    _afficherDialogSuppressionSociete = () => {
        this.setState({ isOpenDialogSuppressionSociete: true });
    };

    _chargementDonnees = () => {
        this.setState({ messageEnCoursTraitement: "Chargement de la société" });
        DataSociete._chargementSociete(this.props.idSociete).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const societe = responseFetch.reponseAPIobjet;
                this.setState(
                    {
                        estSocieteReseau: societe.societeReseau,
                        nom: societe.nom || "",
                        honoraires: societe.honoraireParDefaut ? societe.honoraireParDefaut.replace(" %", "").replace(",", ".") : "",
                        nombreOptionsParOperation: societe.nbreOptionParOperation || "",
                        raisonSociale: societe.raisonSociale || "",
                        siren: societe.siren || "",
                        siret: societe.sirenEtablissement || "",
                        rcs: societe.sirenVille || "",
                        adresse: societe.adresse || "",
                        cp: societe.cp || "",
                        ville: societe.ville || "",
                        pays: societe.pays || "",
                        telephone: societe.tel || "",
                        fax: societe.fax || "",
                        /* ----- */
                        messageEnCoursTraitement: "",
                    },
                    this._onVerificationFormulaire
                    //this._setErrorMessages(["nom", "honoraires", "nombreOptionsParOperation", "raisonSociale", "siren", "siret", "rcs", "cp", "ville"])
                )
            }
            else
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
        });
    };

    _getErrorMessage = (champs) => {
        const value = this.state[champs];
        switch (champs) {
            case "honoraires":
                if (!(/(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/.test(value))) // Pourcentage
                    return "La valeur saisie n'est pas un pourcentage valide.";
                else return null;
            case "nombreOptionsParOperation":
                if (isNaN(value))
                    return "La valeur saisie n'est pas un nombre valide.";
                else if (value < 0)
                    return "La valeur doit être positive.";
                else return null;
            case "siren": return !(/^$|^\d{9}$/.test(value)) ? "Ce champs doit contenir 9 chiffres." : null; // Chaîne vide ou 9 chiffres
            case "siret": return !(/^$|^\d{5}$/.test(value)) ? "Ce champs doit contenir 5 chiffres." : null; // Chaîne vide ou 5 chiffres
            default: return null;
        }
    };

    _masquerDialogSuppressionSociete = () => {
        this.setState({ isOpenDialogSuppressionSociete: false });
    };

    _setErrorMessage = (champs) => () => {
        //this._setErrorMessages([champs])();
        let newErrorMessages = { ...this.state.errorMessages };
        const errorMessage = this._getErrorMessage(champs);
        if (errorMessage)
            newErrorMessages[champs] = errorMessage;
        else
            delete newErrorMessages[champs];
        this.setState({ errorMessages: newErrorMessages });
    };

    _setErrorMessages = (tableauDeChamps) => () => {
        let newErrorMessages = { ...this.state.errorMessages };
        tableauDeChamps.forEach(champs => {
            const errorMessage = this._getErrorMessage(champs);
            if (errorMessage)
                newErrorMessages[champs] = errorMessage;
            else
                delete newErrorMessages[champs];
        });
        this.setState({ errorMessages: newErrorMessages });
    };

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnulation();
    };

    _onChangeInput = (champ) => (event, newValue) => {
        this.setState(
            { [champ]: newValue },
            this._onVerificationFormulaire
            //this._setErrorMessage(champs)
        );
    };

    _onEnregistrement = () => {

        this.setState({ messageEnCoursTraitement: "Société en cours d'enregistrement..." });

        const societe = {
            idSociete: this.props.idSociete,
            estSocieteReseau: this.state.estSocieteReseau,
            nom: this.state.nom,
            honoraires: `${this.state.honoraires.replace(".", ",")} %`,
            nombreOptionsParOperation: this.state.nombreOptionsParOperation,
            raisonSociale: this.state.raisonSociale,
            siren: this.state.siren,
            siret: this.state.siret,
            rcs: this.state.rcs,
            adresse: this.state.adresse,
            cp: this.state.cp,
            ville: this.state.ville,
            pays: this.state.pays,
            telephone: this.state.telephone,
            fax: this.state.fax,
        }

        DataSociete._onEnregistrementSociete(societe).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                this._onInit();
                this.props.onEnregistrement();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });

    };

    _onInit = () => {
        this.setState(this.objetState);
    };

    _onOpen = () => {
        if (this.props.idSociete)
            this._chargementDonnees();
    };

    _onRenderFooterContent = () => {
        let disabledButton = !this.state.onActiveBoutonEnregistrer;

        return <Stack horizontal tokens={{ childrenGap: 10 }}>
            <PrimaryButton onClick={this._onEnregistrement} disabled={disabledButton}>Enregistrer</PrimaryButton>
            <PrimaryButton onClick={this._afficherDialogSuppressionSociete} disabled={!this.props.idSociete}>Supprimer</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
        </Stack>
    };

    _onSuppression = () => {
        this._masquerDialogSuppressionSociete();
        this.setState({ messageEnCoursTraitement: "Suppression en cours..." });

        DataSociete._onSuppressionSociete(this.props.idSociete).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                this._onInit();
                this.props.onSuppression();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    };

    _onVerificationFormulaire() {
        const societe = {
            idSociete: this.props.idSociete,
            estSocieteReseau: this.state.estSocieteReseau,
            nom: this.state.nom,
            honoraires: `${this.state.honoraires.replace(".", ",")} %`,
            nombreOptionsParOperation: this.state.nombreOptionsParOperation,
            raisonSociale: this.state.raisonSociale,
            siren: this.state.siren,
            siret: this.state.siret,
            rcs: this.state.rcs,
            adresse: this.state.adresse,
            cp: this.state.cp,
            ville: this.state.ville,
            pays: this.state.pays,
            telephone: this.state.telephone,
            fax: this.state.fax,
        }

        Immocom.fiche()._validationFormulaire(this, 'Societe', societe, (societe.idSociete > 0 ? 'Modification' : 'Création'));
    }

    render = () => {

        return <Fragment>
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.props.idSociete ? "Modifier une société" : "Créer une société"}
                isOpen={this.props.isOpen}
                onDismiss={this._onAnnulation}
                onOpen={this._onOpen}
                onOuterClick={() => { }} // Empêche la fermeture du panel à la fermeture de la dialog : https://github.com/microsoft/fluentui/issues/6476
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.medium}
            >

                {this.state.messageEnCoursTraitement.length > 0 ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <Checkbox
                                checked={this.state.estSocieteReseau}
                                label="Société Réseau"
                                onChange={this._onChangeInput("estSocieteReseau")}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Nom"
                                maxLength={MaxLengths.societe.nom}
                                onDelayedChange={this._onChangeInput("nom")}
                                required
                                value={this.state.nom}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                errorMessage={this.state.errorMessages.honoraires}
                                label="Honoraires"
                                min={0}
                                max={100}
                                onBlur={this._setErrorMessage("honoraires")}
                                onChange={this._onChangeInput("honoraires")}
                                required
                                suffix="%"
                                type="number"
                                validateOnLoad={false}
                                value={this.state.honoraires}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                errorMessage={this.state.errorMessages.nombreOptionsParOperation}
                                label="Nombre d'options par opération"
                                min={1}
                                onChange={this._onChangeInput("nombreOptionsParOperation")}
                                onBlur={this._setErrorMessage("nombreOptionsParOperation")}
                                required
                                type="number"
                                validateOnLoad={false}
                                value={this.state.nombreOptionsParOperation}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Raison sociale"
                                maxLength={MaxLengths.societe.raisonSociale}
                                onDelayedChange={this._onChangeInput("raisonSociale")}
                                required
                                value={this.state.raisonSociale}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                errorMessage={this.state.errorMessages.siren}
                                label="SIREN"
                                maxLength={MaxLengths.societe.siren}
                                onDelayedChange={this._onChangeInput("siren")}
                                placeholder="9 chiffres"
                                validateOnLoad={false}
                                value={this.state.siren}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                errorMessage={this.state.errorMessages.siret}
                                label="SIRET"
                                maxLength={MaxLengths.societe.sirenEtablissement}
                                onDelayedChange={this._onChangeInput("siret")}
                                placeholder="5 chiffres"
                                prefix={this.state.siren || "SIREN"}
                                validateOnLoad={false}
                                value={this.state.siret}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="RCS"
                                maxLength={MaxLengths.societe.sirenVille}
                                onDelayedChange={this._onChangeInput("rcs")}
                                placeholder="Ville"
                                prefix="RCS"
                                suffix={this.state.siren || "SIREN"}
                                value={this.state.rcs}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Adresse"
                                maxLength={MaxLengths.societe.adresse}
                                onDelayedChange={this._onChangeInput("adresse")}
                                value={this.state.adresse}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="CP"
                                maxLength={MaxLengths.societe.cp}
                                onDelayedChange={this._onChangeInput("cp")}
                                required
                                value={this.state.cp}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Ville"
                                maxLength={MaxLengths.societe.ville}
                                onDelayedChange={this._onChangeInput("ville")}
                                required
                                value={this.state.ville}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Pays"
                                maxLength={MaxLengths.societe.pays}
                                onDelayedChange={this._onChangeInput("pays")}
                                value={this.state.pays}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Téléphone"
                                maxLength={MaxLengths.societe.tel}
                                onDelayedChange={this._onChangeInput("telephone")}
                                placeholder={"+33"}
                                value={this.state.telephone}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Fax"
                                maxLength={MaxLengths.societe.fax}
                                onDelayedChange={this._onChangeInput("fax")}
                                value={this.state.fax}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <Dialog
                hidden={!this.state.isOpenDialogSuppressionSociete}
                onDismiss={this._masquerDialogSuppressionSociete}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: `Supprimer une société`,
                    subText: `La société « ${this.state.nom} », ses mandats et les comptes utilisateurs qui lui sont rattachés seront supprimés définitivement, confirmez-vous ce choix ?`
                }}
                modalProps={{
                    isBlocking: false,
                    styles: { main: { maxWidth: 450 } }
                }}>
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppression} text="Confirmer" />
                    <DefaultButton onClick={this._masquerDialogSuppressionSociete} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>
    };

}
